import { PagesName } from '../constants';
import { Destination } from './api/Destination';
import {
  AvailableLocale,
  CommsFormElement,
  FooterData,
  HeaderRoute,
  NavigationRoute,
  NotFoundPageRoute,
  Sidebar,
} from './api/PageConfig';

export enum ConfigLoaded {
  Loading = 0,
  Loaded = 1,
  Error = 2,
}
export interface Cookies {
  accepted: boolean;
  functional: boolean;
  marketing: boolean;
  analytics: boolean;
  personalization: boolean;
}
export interface CookiesConfig {
  cookies: Cookies;
  setCookies: (cookies: Cookies) => void;
}

/** @deprecated use `CmsControlledConfig` instead */
export type Config = {
  locale: string | null;
  locales: AvailableLocale[];
  routes: NavigationRoute[];
  header?: HeaderRoute[];
  footer?: FooterData;
  sidebars?: Array<Sidebar[]>;
  helpBlock?: PagesName[];
  welcomeCasinoCategories?: string[];
  featuredCasinoCategories?: string[];
  customContentPages?: string[];
  configLoaded: ConfigLoaded;
  cookies: Cookies;
  showPageLoader: boolean;
  domLoaded: boolean;
  mobileView: boolean;
  notFoundPageRoutes?: NotFoundPageRoute[];
  communicationPrefsPageForm?: CommsFormElement[];
  hardcodedCategoriesBanners?: {
    slug: string;
    image?: string;
    mobile_banner?: string;
    desktop_banner?: string;
  }[];
  zendeskDisabled?: any;
  destinations?: Destination[];
};

export type CmsControlledConfig = {
  locale: string | null;
  locales: AvailableLocale[];
  routes: NavigationRoute[];
  header?: HeaderRoute[];
  footer?: FooterData;
  sidebars?: Array<Sidebar[]>;
  helpBlock?: PagesName[];
  welcomeCasinoCategories?: string[];
  featuredCasinoCategories?: string[];
  customContentPages?: string[];
  configLoaded: ConfigLoaded;
  cookies: Cookies;
  showPageLoader: boolean;
  domLoaded: boolean;
  mobileView: boolean;
  notFoundPageRoutes?: NotFoundPageRoute[];
  communicationPrefsPageForm?: CommsFormElement[];
  hardcodedCategoriesBanners?: {
    slug: string;
    image?: string;
    mobile_banner?: string;
    desktop_banner?: string;
  }[];
  destinations?: Destination[];
};

/** @deprecated do not use default export for types, and use `CmsControlledConfig` instead of `Config` */
export default Config;
